import { render, staticRenderFns } from "./ContactDashboardItem.vue?vue&type=template&id=fb3c9a6a&scoped=true"
import script from "./ContactDashboardItem.vue?vue&type=script&lang=js"
export * from "./ContactDashboardItem.vue?vue&type=script&lang=js"
import style0 from "./ContactDashboardItem.vue?vue&type=style&index=0&id=fb3c9a6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3c9a6a",
  null
  
)

export default component.exports